import React, { useEffect } from 'react'
import HomeSlider from './Home/HomeSlider'
import { allapiAction } from '../Redux/common/action';
import ContactHome from './ContactHome';

function Contact() {

  return (
    <div>
       <div>
        <img src="img/jj.jpg" style={{width:"100%",height:'380px'}}     />
       </div>
    <div class="contact_new">
           <div class="container"  style={{marginTop:"80px"}}>
        <div class="row text-center justify-content-center">
            <div class="col-md-4">
                <div class="contact-box">
                    <i class="bi bi-geo-alt-fill"></i>
                    <h5>Address</h5>
                    <p>B/904, Titanium Square, Thaltej Cross Road, Near BMW Showroom, S G Highway, Thaltej, Ahmedabad, Gujarat 380054, India</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="contact-box">
                    <i class="bi bi-phone-fill"></i>
                    <h5>Phone Number</h5>
                    <p>+91 8000450380</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="contact-box">
                    <i class="bi bi-envelope-fill"></i>,
                    <h5>Email Address</h5>
                    <p>chitracropscience22@gmail.com</p>
                </div>
            </div>
        </div>
        
        <h4 class="mt-5 text-center">Contact Form</h4>
        <ContactHome />
        {/* <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="row">
                    <div class="col-md-6 mt-3">
                        <input type="text" class="form-control" placeholder="Name"/>
                    </div>
                    <div class="col-md-6 mt-3">
                        <input type="text" class="form-control" placeholder="Phone Number"/>
                    </div>
                    <div class="col-md-6 mt-5">
                        <input type="email" class="form-control" placeholder="Email Address"/>
                    </div>
                    <div class="col-md-6 mt-5">
                        <input type="text" class="form-control" placeholder="Subject"/>
                    </div>
                    <div class="col-12 mt-5">
                        <textarea class="form-control" rows="4" placeholder="Message"></textarea>
                    </div>
                    <div class="col-12 mt-4 text-center">
                        <button class="btn btn-success">Submit</button>
                    </div>
                </div>
            </div>
        </div> */}
    </div>
    </div>
    </div>
  )
}

export default Contact